<template>
  <div
    class="form-element"
    :class="{
      '_free-height': freeHeight,
      '_small': small,
    }"
    :style="styles"
  >
    <div class="-over-the-box">
      <div class="--label">
        <slot name="label" />
      </div>

      <div class="--warning">
        <slot name="warning" />
      </div>
    </div>

    <div class="-box"
      :class="{
        '_borderless': borderless,
      }"
    >
      <div class="--input">
        <slot />
      </div>

      <div class="--controller" v-if="hasControllerSlot">
        <slot name="controller" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    borderless: {
      type: Boolean,
      default: false
    },
    freeHeight: {
      type: Boolean,
      default: false
    },
    styles: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasControllerSlot () {
      return !!this.$slots['controller']
    }
  }
}
</script>

<style lang="scss" scoped>
.form-element {
  min-width: 300px;
  width: calc(100% - 4px);
  margin: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  & .-over-the-box {
    width: calc(100% - 20px);
    margin-left: 12px;
    margin-right: 8px;
    align-items: baseline;
    display: inline-flex;
    justify-content: space-between;

    & .--label {
      flex: 1 1 auto;

      & span {
        font-size: 1.2rem;
        line-height: 2rem;
      }
    }

    & .--warning {
      min-width: 100px;
      flex: 0 0 auto;
      text-align: right;

      & span {
        font-size: 0.8rem;
        line-height: 1rem;
        color: red;
        letter-spacing: 0.6px;
      }
    }
  }

  & .-box {
    width: 100%;
    min-height: 48px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: inline-flex;
    justify-content: space-between;
    padding: 4px;
    background-color: #fff;
    -webkit-box-shadow: 0px 1px 2px 0px rgba(60, 64, 67, 0.1), 0px 1px 3px 1px rgba(60, 64, 67, 0.15);
    box-shadow: 0px 1px 2px 0px rgba(60, 64, 67, 0.1), 0px 1px 3px 1px rgba(60, 64, 67, 0.15);
    border-radius: 8px;
    transition: all ease-in 0.2s;

    &:hover {
      -webkit-box-shadow: 0px 1px 3px 0px rgba(60, 64, 67, 0.2), 0px 4px 8px 3px rgba(60, 64, 67, 0.15);
      box-shadow: 0px 1px 3px 0px rgba(60, 64, 67, 0.2), 0px 4px 8px 3px rgba(60, 64, 67, 0.15);
    }

    &._borderless {
      box-shadow: none;
    }


    & .--input {
      flex: 2 2 auto;
      width: 100%;
      & * {
        width: calc(100% - 4px);
        height: 100%;
      }
    }

    & .--controller {
      flex: 1 1 auto;
      width: auto;
      height: 100%;
      margin-left: 5px;
      display: inline-flex;
      justify-content: flex-end;
      align-items: center;

      & button {
        width: 24px;
        height: 24px;
        padding: 4px;
        margin: 2px;
        line-height: 8px;
        border: none;
        transition: all ease-in 0.1s;
        color: #ddd;

        &:hover {
          // border-color: #eee;
          color: #666;
        }
      }
    }
  }

  &._free-height {
    height: calc(100% - 40px);

    & .-box {
      height: calc(100% - 90px);
    }
  }
}
</style>
  